import React, { useState } from 'react';

export default function DocumentsSection() {
  const [pdfModal, setPdfModal] = useState(null);

  const documents = [
    {
      id: 1,
      title: 'Terms and Conditions',
      description: 'Read our terms and conditions to understand our policies',
      file: 'documents/doc1.pdf'
    },
    {
      id: 2,
      title: 'Privacy Policy',
      description: 'Learn how we collect, use, and protect your personal information',
      file: 'documents/doc2.pdf'
    },
    {
      id: 3,
      title: 'SEC Filing',
      description: 'Access our official SEC filing documents and regulatory reports',
      file: 'documents/doc3.pdf'
    }
  ];

  return (
    <section className="documents-section" id="documents">
      <div className="documents-container">
        <h1>Our Documents</h1>
        <p className="documents-subtitle">Browse and download our latest documents and resources</p>

        <div className="documents-grid">
          {documents.map((doc) => (
            <div key={doc.id} className="pdf-card">
              <div className="pdf-icon"><i className="fa-solid fa-file-pdf"></i></div>
              <h3>{doc.title}</h3>
              <p className="pdf-description">{doc.description}</p>
              <div className="pdf-actions">
                <a href={doc.file} className="pdf-link" download>Download PDF</a>
                <button className="pdf-view" onClick={() => setPdfModal(doc.file)}>View</button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {pdfModal && (
        <div className="pdf-modal" onClick={() => setPdfModal(null)}>
          <div className="pdf-modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-btn" onClick={() => setPdfModal(null)}>&times;</span>
            <iframe title="PDF Viewer" src={pdfModal} frameBorder="0"></iframe>
          </div>
        </div>
      )}
    </section>
  );
}
